import * as React from 'react';
import * as acl from 'common/utils/acl';

import { Route, RouteComponentProps } from 'react-router-dom';

import { AppState } from 'common/models/AppState';
import { EntityActions } from 'common/entity/EntityActions';
import { OrdersDetail } from './OrdersDetails';
import { OrdersTable } from './OrdersTable';
import { Page } from 'common/components/layout/Page/Page';
import { Search } from 'common/components/Search';
import { UserPermissions } from 'common/api/models/UserPermissions';

export interface OrdersProps extends RouteComponentProps<{}> {
  appState: AppState;
  entityActions: EntityActions;
}
export interface OrdersState {
  error?: string;
  reloadAt: Date;
}

export class Orders extends React.Component<OrdersProps, OrdersState> {
  state: OrdersState = { reloadAt: new Date() };

  handleClickRow = (orderNumber: number) => {
    this.props.history.push('/orders/' + orderNumber);
  };

  handleSubmitSearch = (value: string) => {
    this.props.history.push('/orders/' + value);
  };

  render() {
    return (
      <div>
        <Route
          path="/orders"
          exact={true}
          render={(props: RouteComponentProps<{}>) => (
            <Page
              title="Orders"
              primaryAction={{
                to: '/checkout',
                label: 'Place Order',
                shouldRender: acl.hasPermission(this.props.appState, UserPermissions.Permissions.CREATE_ORDER),
              }}
            >
              {this.state.error && (
                <div className="alert alert-danger" style={{ marginTop: 20 }}>
                  {this.state.error}
                </div>
              )}
              <div className="card card-responsive">
                <div className="p-3 p-sm-4">
                  <div>
                    <Search placeholder="Search by order id" initialValue="" onSubmit={this.handleSubmitSearch} />
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <OrdersTable
                      appState={this.props.appState}
                      entityActions={this.props.entityActions}
                      reloadAt={this.state.reloadAt}
                      onClick={this.handleClickRow}
                    />
                  </div>
                </div>
              </div>
            </Page>
          )}
        />
        <Route
          path="/orders/:num"
          render={(props: RouteComponentProps<{ num: number }>) => (
            <OrdersDetail
              appState={this.props.appState}
              entityActions={this.props.entityActions}
              orderNumber={props.match.params.num}
            />
          )}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/Orders.tsx